<template>
    <div>
        <a-page-header class="page-header icon" @back="() => null" :sub-title="sub_title">
            <svg class="icon" aria-hidden="true" slot="backIcon" @click="$router.replace('/log')">
                <use xlink:href="#icon-zhuji" />
            </svg>

            <template #title>系统<a-icon class="separator" type="right" /> </template>

            <template slot="extra">
                <div class="extra-shortcut">
                    <a-icon type="plus-circle" class="pointer" @click="on_add_shortcut" />
                </div>
            </template>
        </a-page-header>

        <div class="framework-container">
            <div
                class="framework-side"
                :class="[visible_sidebar ? 'visible' : '', small_screen ? 'ss' : '', visible_sidebar ? 'tg-on' : 'tg-off']"
            >
                <div class="module-title">
                    组织管理
                </div>

                <a-menu class="menu" mode="inline" v-model="selected_menu" :inlineIndent="16" :default-open-keys="['user', 'member']">
                    <a-menu-item key="organization" @click="on_jump('organization')">组织管理</a-menu-item>
                    <a-menu-item key="captcha" @click="on_jump('captcha')">短信验证码</a-menu-item>

                    <a-menu-item-group title="系统日志">
                        <a-menu-item key="member_login" @click="on_jump('member_login')">前端用户登录日志</a-menu-item>
                        <a-menu-item key="member_request" @click="on_jump('member_request')">前端用户操作日志</a-menu-item>
                        <a-menu-item key="user_login" @click="on_jump('user_login')">后台用户登录日志</a-menu-item>
                        <a-menu-item key="user_request" @click="on_jump('user_request')">后台用户操作日志</a-menu-item>
                    </a-menu-item-group>
                </a-menu>
            </div>

            <div class="framework-body" :class="[visible_sidebar ? 'tg-on' : 'tg-off', small_screen ? 'ss' : '']">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selected_menu: ["user", "member"],
                sub_title: "登录日志",
                menu: [
                    { name: "后台用户登录日志", value: "user_login" },
                    { name: "后台用户操作日志", value: "user_request" },
                    { name: "前端用户登录日志", value: "member_login" },
                    { name: "前端用户操作日志", value: "member_request" },
                    { name: "短信验证码", value: "captcha" },
                    { name: "任务调度", value: "schedule" },
                    { name: "组织管理", value: "organization" },
                ],
            };
        },
        created() {
            this.where();
        },
        watch: {
            $route() {
                this.where();
            },
        },
        methods: {
            where() {
                let current = window.location.pathname.split("/").pop();
                this.selected_menu = [current];

                this.menu.filter((v) => {
                    if (current === v.value) {
                        this.sub_title = v.name;
                    }
                });
            },
            on_jump(v) {
                return this.$router.push(`/system/${v}`);
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-container {
        .framework-side {
            .toolbar {
                .item {
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;
                    cursor: pointer;
                    .text {
                        font-size: 12px;
                    }
                }
            }
        }
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
        }
    }
</style>
